import { useMutation, useQueryClient } from "@tanstack/react-query"
import { profile } from "@shared/api/services"

export const useUpdateEmailResend = () => {
	const queryClient = useQueryClient()

	const mutation = useMutation({
		mutationFn: () => profile.updateEmailResend(),
    onSuccess: () => {
      queryClient.invalidateQueries(['profile'])
      queryClient.invalidateQueries(['resend-email-available'])
    },
  })

	return mutation
}